{
	"title": "Facturi",
	"buttonShowMoreInvoicesTitle": "Afișează mai multe facturi",
	"invoicesTableHeaders": {
		"date": "Data",
		"invoiceNumber": "Număr factură",
		"deliveredQuantity": "Cantitate livrată",
		"bundledCarbonSavings": "Reduceri de CO\u2082 incluse",
		"transactionId": "ID tranzacție"
	},
	"errorMessage": "Încărcarea facturilor a eșuat"
}
